import { useConfig } from "context/configContext";
import { showDeliverToGate } from "../config/envConfig";
import apiList from "../services/apiList";
import { callApi } from "../services/callApi";
import Util from "./util";
import { DATA_REFERENCE, DELIVERY_ENABLED } from "./Constants";
import {
  getLocalStorage,
  getSessionStorage,
  setSessionStorage,
} from "./storageUtil";

export const decode = (item) => {
  let newItem = window.atob(item);
  return newItem;
};

export const encode = (item) => {
  let newItem = window.btoa(item);
  return newItem;
};

export const deleteAllCookies = () => {
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
};

export const getCookieCustom = (cName) => {
  const name = cName + "=";
  const cDecoded = decodeURIComponent(document.cookie); //to be careful
  const cArr = cDecoded.split("; ");
  let res;
  cArr.forEach((val) => {
    if (val.indexOf(name) === 0) res = val.substring(name.length);
  });

  return res;
};

export const setCookieCustom = (key, value) => {
  document.cookie = `${key}=${JSON.stringify(
    value
  )};max-age=${cookieValidity};path='/'`;
};

export const removeCookieCustom = (name) => {
  document.cookie = `${name}= ; expires = Thu, 01 Jan 1970 00:00:00 GMT`;
};

export const cookieValidity = 60 * 60 * 24 * 30;

export const isLoggedIn = () => {
  const kioskUser = getCookieCustom("kioskUser");
  if (kioskUser) return true;
  else return false;
};

export const formatRupees = (number) => {
  // Convert the number to a string
  const strNumber = number.toString();
  // Split the number into integer and decimal parts (if any)
  const parts = strNumber.split(".");
  let integerPart = parts[0];
  const decimalPart = parts[1] ? "." + parts[1] : "";

  // Add commas to the integer part
  const regex = /(\d)(?=(\d{3})+(?!\d))/g;
  integerPart = integerPart.replace(regex, "$1,");

  if (decimalPart === ".00") {
    // If the decimal part is ".00", remove it
    return integerPart;
  }
  // Return the formatted rupees
  return integerPart + decimalPart;
};

export const size = {
  mobileS: "320px",
  mobileM: "375px",
  mobileP: "390px",
  mobileX: "414px",
  mobileL: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1440px",
  desktop: "2560px",
  kiosk: "1079px",
};

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileP: `(min-width: ${size.mobileP})`,
  mobileX: `(min-width: ${size.mobileX})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet}) and (max-width: ${size.kiosk})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktop})`,
  kiosk: `(min-width: ${size.kiosk})`,
};

export const isTab = () => {
  if (
    window.matchMedia("screen and (min-width: 800px) and (max-width: 1079px)")
      .matches
  ) {
    return true;
  } else {
    return false;
  }
};

export const showDeliveryOption = () => {
  const data = JSON.parse(localStorage.getItem(DATA_REFERENCE));
  const fallbackDeliveryFlag = showDeliverToGate === "true";
  if (data && data[DELIVERY_ENABLED]) {
    if (data[DELIVERY_ENABLED]?.toLowerCase() === "yes") {
      return true;
    } else {
      return false;
    }
  } else {
    return fallbackDeliveryFlag;
  }
};

export const sendMessageToReactNative = (msg) => {
  if (window.ReactNativeWebView) {
    if (msg !== undefined) {
      window.ReactNativeWebView.postMessage(msg);
    }
  }
};

export const getUserInfo = async (type) => {
  try {
    let apiURL = apiList.user.info;
    let apiResponse;

    apiResponse = await callApi.get(apiURL);

    if (apiResponse.status === 200) {
      if (type === "metadata") {
        return apiResponse.metadata;
      } else if (type === "both") {
        return apiResponse;
      } else {
        return apiResponse.data;
      }
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const removeAppliedCoupon = () => {
  let promoData = JSON.parse(
    JSON.stringify(getSessionStorage("availablePromo"))
  );
  promoData?.data?.forEach((x) => {
    if (x.couponCode) {
      delete x.couponCode;
    }
  });
  setSessionStorage("availablePromo", promoData);
};

export const isValidPrice = (val) => {
  if (val !== null && val !== undefined && val !== 0) {
    return true;
  } else {
    return false;
  }
};

export const formatPrice = (amount) => {
  if (typeof amount === "string") {
    amount = amount.replace(/,/g, "");
    amount = parseFloat(amount);
  }

  const configData = getLocalStorage("config") || {};
  const countryCode = configData?.countryCode || "US";

  const optionsByCountry = {
    US: {
      locale: "en-US",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      truncate: true,
    },
    DK: {
      locale: "da-DK",
      currency: "DKK",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      truncate: false,
    },
    GB: {
      locale: "en-GB",
      currency: "GBP",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      truncate: true,
    },
    // Add more countries as needed
  };

  const options = optionsByCountry[countryCode];
  let displayAmount = amount;
  if (options.truncate) {
    displayAmount = truncateTo2DecimalsStr(displayAmount);
  }

  const formatter = new Intl.NumberFormat(options.locale, {
    style: "currency",
    currency: options.currency,
    minimumFractionDigits: options.minimumFractionDigits,
    maximumFractionDigits: options.maximumFractionDigits,
  });

  let formatted = formatter.format(displayAmount);

  // Remove period from 'kr.' if country is Denmark
  if (countryCode === "DK") {
    formatted = formatted.replace("kr.", "kr");
  }

  return `${formatted}`;
};

export const truncateTo2DecimalsStr = (num) => {
  if (isNaN(num) || num === null || num === undefined) {
    return "";
  }
  const [intPart, decimalPart = ""] = num?.toString()?.split(".");
  const truncatedDecimal = decimalPart?.slice(0, 2)?.padEnd(2, "0");
  return `${intPart}.${truncatedDecimal}`;
};

export function getFileType(url) {
  const fileTypeRegex = /\.(mp4|mov|avi|mkv|webm)$/i;
  const imageTypeRegex = /\.(jpg|jpeg|png|gif|bmp|svg|webp)$/i;

  if (fileTypeRegex.test(url)) {
    return "video";
  } else if (imageTypeRegex.test(url)) {
    return "image";
  }

  return "unknown";
}

export default function isJFK() {
  const host = window.location.hostname;
  return host.includes("jfk") || host.includes("localhost");
}

export function makeUnique(base) {
  var now = new Date().getTime();
  var random = Math.floor(Math.random() * 100000);
  random = "" + random;
  while (random.length < 5) {
    random = "0" + random;
  }
  return base + now + random;
}

export const useCallV2API = () => {
  const { config } = useConfig();

  return config?.platforms?.some(
    (platform) =>
      platform?.platformName?.toLowerCase() === "kiosk" && platform?.callV2API
  );
};

export const loginWithDefaultCreds = async ({
  firstName = "",
  lastName = "",
} = {}) => {
  const ts = Date.now().toString();
  const userObj = {
    firstName: firstName || `test_${ts}`,
    lastName: lastName || `test_${ts}`,
    email: `${ts}@gmail.com`,
    countryCode: "1",
    mobile: ts.slice(-10),
    segment: { code: "G" },
    subscription: {
      email: { newsletter: false, promotions: false, offers: false },
      sms: { newsletter: false, promotions: false, offers: false },
      notifications: { newsletter: false, promotions: false, offers: false },
    },
  };
  const param = btoa(JSON.stringify(userObj));
  const headers = Util.getAuthHeaders();
  headers["x-enforce-2fa"] = 0;

  const regResponse = await callApi.put(
    apiList.auth.initiate,
    { params: param },
    headers
  );

  if (!regResponse?.status?.toString()?.startsWith("20")) {
    return false;
  }

  setSessionStorage("guestUserData", userObj);

  return true;
};
